<template>
  <v-container>
    <date-picker-filter :firstDay="firstDay" :lastDay="lastDay">
      <template #otherFilter>
        <v-col cols="12" lg="6">
          <v-autocomplete
            v-model="camp_ids"
            :items="camps"
            item-text="name"
            item-value="id"
            outlined
            chips
            small-chips
            label="Filter By Camp"
            multiple
            deletable-chips
            @change="handleFilter"
            @click:clear="removeFilter"
          ></v-autocomplete>
        </v-col>
      </template>
    </date-picker-filter>
    <v-row>
      <v-col cols="12" md="6" class="mx-auto">
        <ReservationStatistics style="width: 500px; margin: auto" />
      </v-col>
      <v-col cols="12" md="6" class="mx-auto">
        <LocationStatistics style="width: 500px; margin: auto" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" class="mx-auto">
        <HearingSourceStatistics style="width: 500px; margin: auto" />
      </v-col>
      <v-col cols="12" md="6" class="mx-auto">
        <CampersAttendanceStatistics style="width: 500px; margin: auto" />
      </v-col>
      <v-col cols="12" md="6" class="mx-auto">
        <BusExtras style="width: 500px; margin: auto" />
      </v-col>
      <v-col cols="12" md="6" class="mx-auto">
        <EarlyCheckInExtras style="width: 500px; margin: auto" />
      </v-col>
      <v-col cols="12" md="6" class="mx-auto">
        <SpecialNeedsExtras style="width: 500px; margin: auto" />
      </v-col>
      <v-col cols="12" md="6" class="mx-auto">
        <LateCheckOutExtras style="width: 500px; margin: auto" />
      </v-col>
      <v-col cols="12" md="6" class="mx-auto">
        <PhotoExtras style="width: 500px; margin: auto" />
      </v-col>
      <v-col cols="12" md="6" class="mx-auto">
        <MealExtras style="width: 500px; margin: auto" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";
export default {
  name: "ReportsCharts",
  components: {
    ReservationStatistics: () => import("@/components/ReservationStatistics"),
    LocationStatistics: () => import("@/components/LocationStatistics"),
    HearingSourceStatistics: () =>
      import("@/components/HearingSourceStatistics"),
    CampersAttendanceStatistics: () =>
      import("@/components/CampersAttendanceStatistics"),
    BusExtras: () => import("@/components/BusExtras"),
    EarlyCheckInExtras: () => import("@/components/EarlyCheckInExtras"),
    SpecialNeedsExtras: () => import("@/components/SpecialNeedsExtras"),
    LateCheckOutExtras: () => import("@/components/LateCheckOutExtras"),
    PhotoExtras: () => import("@/components/PhotoExtras"),
    MealExtras: () => import("@/components/MealExtras"),
    DatePickerFilter: () => import("@/components/DatePickerFilter")
  },
  data() {
    return {
      camps: [],
      camp_ids: [],
      query: {},
      index: 0
    };
  },
  methods: {
    handleFilter() {
      const { from_date, to_date } = this.$route.query;
      this.query = {
        camp_ids: [this.camp_ids]
      };

      if (this.camp_ids.length == 0) {
        this.index = 0;
        const routeQuery = { ...this.$route.query };
        delete routeQuery.camp_ids;
        return this.$router.push({
          query: routeQuery
        });
      } else {
        this.$router.push({
          query: { ...this.$route.query, ...this.query }
        });
      }
    },
    removeFilter() {
      this.query = {};
      this.camp_ids = [];
      this.$router.push({ query: this.query });
    },
    save() {
      this.menu1 = false;
      this.menu2 = false;
    },
    getAllCamps() {
      IndexData({ reqName: "camps", query: { pagination: "all" } }).then(
        res => {
          const { data } = res.data;
          this.camps = data.map(el => {
            return {
              name: el.name,
              id: el.id
            };
          });
        }
      );
    }
  },

  computed: {
    firstDay() {
      return `${new Date().getFullYear()}-01-01`;
    },
    lastDay() {
      return `${new Date().getFullYear()}-12-31`;
    }
  },
  mounted() {
    this.getAllCamps();
  },
  watch: {
    $route: {
      handler({ query }) {
        if (query.camp_ids) {
          this.camp_ids = query.camp_ids[0].map(el => Number(el));
        } else {
          this.camp_ids = [];
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
.v-expansion-panel-header__icon {
  margin: 0 !important;
}
</style>
